export default "__VITE_ASSET__7fe48b18__"